<template>
  <div class="row">
    <div class="sm-12">
      <identificacao-cliente></identificacao-cliente>
      <ul class="list">
        <li v-for="categoria of categorias" class="menu-item">
          <h3>{{ categoria.categoria }}</h3>
          <ul class="inner-list">
            <li v-for="item in categoria.items">
              <menu-item :name="item.name">
                <router-link v-if="'to' in item" :to="item.to" class="square">
                  <i :class="item.icon"></i>
                  {{ item.label }}
                </router-link>
                <a v-if="'href' in item" :href="item.href" :target="item.target" class="square">
                  <i :class="item.icon"></i>
                  {{ item.label }}
                </a>
                <a v-if="'action' in item" @click.prevent.stop="item.action" class="square">
                  <i :class="item.icon"></i>
                  {{ item.label }}
                </a>
              </menu-item>
            </li>
          </ul>
        </li>
      </ul>
      <!--
      <ul class="list" v-if="false">
        
        <li
          v-if="
            controle_acesso &&
            controle_acesso.financeiro &&
            controle_acesso.financeiro.acesso
          "
          class="menu-item">
          <h3>Financeiro</h3>
          <ul class="inner-list">
            <li
              v-if="
                sistema == 'C' &&
                controle_acesso &&
                ((controle_acesso.lancamentoLeituraAgua &&
                  controle_acesso.lancamentoLeituraAgua.acesso) ||
                  (controle_acesso.lancamentoLeituraGas &&
                    controle_acesso.lancamentoLeituraGas.acesso))
              ">
              <router-link :to="'/financeiro/leituras'" class="square">
                <i class="mdi mdi-glasses"></i>
                Leituras
              </router-link>
            </li>
            <li
              v-if="
                controle_acesso &&
                controle_acesso.segundaVia &&
                controle_acesso.segundaVia.acesso
              ">
              <router-link :to="'/financeiro/segunda-via'" class="square">
                <i class="mdi mdi-barcode"></i>
                Boletos
              </router-link>
            </li>
            <li
              v-if="
                sistema == 'C' &&
                controle_acesso &&
                controle_acesso.contaCorrente &&
                controle_acesso.contaCorrente.acesso
              ">
              <router-link :to="'/financeiro/conta-corrente'" class="square">
                <i class="mdi mdi-credit-card-check-outline"></i>
                Conta corrente
              </router-link>
            </li>
            <li
              v-if="
                sistema == 'C' &&
                controle_acesso &&
                controle_acesso.relatorioDevedor &&
                controle_acesso.relatorioDevedor.acesso
              ">
              <router-link :to="'/financeiro/inadimplentes'" class="square">
                <i class="mdi mdi-currency-usd-off"></i>
                Inadimplentes
              </router-link>
            </li>
            <li
              v-if="
                sistema == 'C' &&
                controle_acesso &&
                controle_acesso.relatorioDOCs &&
                controle_acesso.relatorioDOCs.acesso
              ">
              <router-link :to="'/financeiro/relacao-valores'" class="square">
                <i class="mdi mdi-cash-multiple"></i>
                Relação de valores
              </router-link>
            </li>
            <li
              v-if="
                sistema == 'C' &&
                controle_acesso &&
                controle_acesso.autorizacaoPagamento &&
                controle_acesso.autorizacaoPagamento.acesso
              ">
              <router-link :to="'/financeiro/autorizacao-notas'" class="square">
                <i class="mdi mdi-account-tie"></i>
                Autorização de notas
              </router-link>
            </li>
            <li
              v-if="
                sistema == 'C' &&
                controle_acesso &&
                controle_acesso.solicitacaoPagamento &&
                controle_acesso.solicitacaoPagamento.acesso
              ">
              <router-link
                :to="'/solicitacao-de-pagamento/busca-fornecedor'"
                class="square">
                <i class="mdi mdi-arrow-collapse"></i>
                Solicitação de pagamento
              </router-link>
            </li>
            <li
              v-if="
                sistema == 'C' &&
                controle_acesso &&
                controle_acesso.solicitacaoPagamento &&
                controle_acesso.solicitacaoPagamento.consulta
              ">
              <router-link
                :to="'/solicitacao-de-pagamento/historico'"
                class="square">
                <i class="mdi mdi-arrow-collapse"></i>
                Histórico de solicitação de pagamento
              </router-link>
            </li>
            <li v-if="controle_acesso">
              <router-link :to="'/seguro-conteudo'" class="square">
                <i class="mdi mdi-lock-open-check-outline"></i>
                Adesão seguro conteúdo
              </router-link>
            </li>
            <li
              v-if="
                sistema == 'C' &&
                controle_acesso &&
                controle_acesso.livroDigital &&
                controle_acesso.livroDigital.acesso
              ">
              <router-link :to="'/financeiro/livro-digital'" class="square">
                <i class="mdi mdi-book-open-page-variant-outline"></i>
                Livro digital
              </router-link>
            </li>
            <li
              v-if="
                sistema == 'C' &&
                controle_acesso &&
                controle_acesso.historicoJuridico &&
                controle_acesso.historicoJuridico.acesso
              ">
              <router-link
                :to="'/financeiro/historico-juridico'"
                class="square">
                <i class="mdi mdi-scale-balance"></i>
                Histórico jurídico
              </router-link>
            </li>
            <li
              v-if="
                sistema == 'C' &&
                controle_acesso &&
                controle_acesso.vencimentoAGO &&
                controle_acesso.vencimentoAGO.acesso
              ">
              <router-link :to="'/financeiro/vencimento-ago'" class="square">
                <i class="mdi mdi-calendar-clock-outline"></i>
                Vencimento AGO
              </router-link>
            </li>
            <li
              v-if="
                sistema == 'C' &&
                controle_acesso &&
                controle_acesso.demonstrativoFinanceiro &&
                controle_acesso.demonstrativoFinanceiro.acesso
              ">
              <router-link
                :to="'/financeiro/demonstrativo-financeiro'"
                class="square">
                <i class="mdi mdi-calculator"></i>
                Demonstrativo financeiro
              </router-link>
            </li>
            <li
              v-if="
                controle_acesso &&
                controle_acesso.informeRendimento &&
                controle_acesso.informeRendimento.acesso
              ">
              <router-link
                :to="'/financeiro/informe-rendimentos'"
                class="square">
                <i class="mdi mdi-chart-histogram"></i>
                Informe de rendimentos
              </router-link>
            </li>
            <li
              v-if="
                sistema == 'A' &&
                controle_acesso &&
                controle_acesso.consultaRecibo &&
                controle_acesso.consultaRecibo.acesso
              ">
              <router-link :to="'/financeiro/consultar-recibos'" class="square">
                <i class="mdi mdi-account-tie"></i>
                Consultar recibos
              </router-link>
            </li>
            <li
              v-if="
                sistema == 'C' &&
                controle_acesso &&
                controle_acesso.graficos &&
                controle_acesso.graficos.acesso
              ">
              <router-link :to="'/financeiro/graficos'" class="square">
                <i class="mdi mdi-finance"></i>
                Gráficos
              </router-link>
            </li>
            <li
              v-if="
                sistema == 'C' &&
                controle_acesso &&
                controle_acesso.relacaoDOCPago &&
                controle_acesso.relacaoDOCPago.acesso
              ">
              <router-link
                :to="'/financeiro/relacao-docs-pagos'"
                class="square">
                <i class="mdi mdi-text-box-check-outline"></i>
                Boletos pagos
              </router-link>
            </li>
          </ul>
        </li>
        
        <li
          v-if="
            sistema == 'C' &&
            controle_acesso &&
            ((controle_acesso.documento && controle_acesso.documento.acesso) ||
              (controle_acesso.dadosCondomino &&
                controle_acesso.dadosCondomino.acesso) ||
              (controle_acesso.solicitacaoNegativa &&
                controle_acesso.solicitacaoNegativa.acesso))
          "
          class="menu-item">
          <h3>Documentos</h3>
          <ul class="inner-list">
            <li
              v-if="
                sistema == 'C' &&
                controle_acesso &&
                controle_acesso.documento &&
                controle_acesso.documento.acesso
              ">
              <router-link :to="'/dados-condominos/documentos'" class="square">
                <i class="mdi mdi-file-document-outline"></i>
                Documentação condominial
              </router-link>
            </li>
            <li
              v-if="
                controle_acesso.dadosCondomino &&
                controle_acesso.dadosCondomino.acesso
              ">
              <router-link
                :to="'/dados-condominos/lista-condomino'"
                class="square">
                <i class="mdi mdi-format-list-checkbox"></i>
                Lista de condôminos
              </router-link>
            </li>
            <li
              v-if="
                controle_acesso &&
                controle_acesso.solicitacaoNegativa &&
                controle_acesso.solicitacaoNegativa.acesso
              ">
              <router-link
                :to="'/dados-condominos/certidao-negativa'"
                class="square">
                <i class="mdi mdi-file-document"></i>
                Certidão negativa
              </router-link>
            </li>
          </ul>
        </li>

        
        <li
          v-if="
            sistema == 'C' &&
            controle_acesso &&
            controle_acesso.reserva &&
            controle_acesso.reserva.acesso
          "
          class="menu-item">
          <h3>Reservas</h3>
          <ul class="inner-list">
            <li>
              <menu-item name="reservar">
                <router-link :to="'/reservas/reservar'" class="square">
                  <i class="mdi mdi-update"></i>
                  Reservar
                </router-link>
              </menu-item>
            </li>
            <li>
              <router-link :to="'/reservas/minhas-reservas'" class="square">
                <i class="mdi mdi-calendar"></i>
                Minhas reservas
              </router-link>
            </li>
            <li v-if="relacao.tipoRelacao == 'S' || relacao.tipoRelacao == 'T'">
              <router-link :to="'/reservas/datas-bloqueadas'" class="square">
                <i class="mdi mdi-calendar"></i>
                Datas bloqueadas
              </router-link>
            </li>
            <li v-if="relacao.tipoRelacao == 'S'">
              <router-link :to="'/reservas/gerenciar-reservas'" class="square">
                <i class="mdi mdi-notebook-edit-outline"></i>
                Gerenciar reservas
              </router-link>
            </li>
            <li v-if="relacao.tipoRelacao == 'S'">
              <router-link :to="'/reservas/reservas-canceladas'" class="square">
                <i class="mdi mdi-book-cancel-outline"></i>
                Cancelamentos
              </router-link>
            </li>
          </ul>
        </li>

        
        <li
          v-if="
            controle_acesso &&
            controle_acesso.assembleia &&
            controle_acesso.assembleia.acesso
          "
          class="menu-item">
          <h3>Assembleias</h3>
          <ul class="inner-list">
            <li>
              <link-assembleias class="square">
                <i class="mdi mdi-human-capacity-increase"></i>
                Todas as assembleias
              </link-assembleias>
            </li>
          </ul>
        </li>

        
        <li
          v-if="
            controle_acesso &&
            controle_acesso.prestadorServico &&
            controle_acesso.prestadorServico.acesso
          "
          class="menu-item">
          <h3>Prestadores de serviços</h3>
          <ul class="inner-list">
            <li>
              <router-link :to="'/prestadores'" class="square">
                <i class="mdi mdi-account-group-outline"></i>
                Lista de prestadores
              </router-link>
            </li>
          </ul>
        </li>

        
        <li
          v-if="
            sistema == 'C' &&
            controle_acesso &&
            controle_acesso.mural &&
            controle_acesso.mural.acesso
          "
          class="menu-item">
          <h3>Mural</h3>
          <ul class="inner-list">
            <li
              v-if="
                controle_acesso &&
                controle_acesso.quadroAviso &&
                controle_acesso.quadroAviso.acesso
              ">
              <router-link :to="'/mural/quadro-de-avisos'" class="square">
                <i class="mdi mdi-bulletin-board"></i>
                Quadro de avisos
              </router-link>
            </li>
            <li
              v-if="
                controle_acesso &&
                controle_acesso.chamaSindico &&
                controle_acesso.chamaSindico.acesso
              ">
              <router-link :to="'/mural/chama-o-sindico'" class="square">
                <i class="mdi mdi-account-search"></i>
                Chama o síndico / condôminos
              </router-link>
            </li>
            <li
              v-if="
                controle_acesso &&
                controle_acesso.agendaSindico &&
                controle_acesso.agendaSindico.acesso
              ">
              <router-link :to="'/mural/agenda-sindico'" class="square">
                <i class="mdi mdi-calendar-star"></i>
                Agenda do síndico
              </router-link>
            </li>
            <li
              v-if="
                controle_acesso &&
                controle_acesso.notificacaoMudanca &&
                controle_acesso.notificacaoMudanca.acesso
              ">
              <router-link :to="'/mural/notificacao-mudanca'" class="square">
                <i class="mdi mdi-comment-bookmark-outline"></i>
                Notificação de Mudança
              </router-link>
            </li>
            <li
              v-if="
                ['00086359002', '70763605000'].includes(
                  cliente.cpf.replace(/\D+/gim, '')
                ) /*
                 ||
                (controle_acesso &&
                  controle_acesso.notificacaoPortaria &&
                  controle_acesso.notificacaoPortaria.acesso)
                */
              ">
              <router-link :to="'/mural/notificacao-portaria'" class="square">
                <i class="mdi mdi-comment-bookmark-outline"></i>
                Notificação portaria
              </router-link>
            </li>
          </ul>
        </li>

        
        <li v-if="sistema == 'C'" class="menu-item">
          <h3>Administração do condomínio</h3>
          <ul class="inner-list">
            <li>
              <router-link
                :to="'/administracao-condominio/dados-sindico'"
                class="square">
                <i class="mdi mdi-account-tie"></i>
                Dados do síndico
              </router-link>
            </li>
          </ul>
        </li>
        
        <li class="menu-item">
          <h3>Conta</h3>
          <ul class="inner-list">
            <li
              v-if="
                controle_acesso &&
                controle_acesso.meusDados &&
                controle_acesso.meusDados.acesso
              ">
              <router-link :to="'/meus-dados'" class="square">
                <i
                  class="mdi mdi-account-supervisor"
                  style="font-size: 76px; line-height: 0.8"></i>
                Meu perfil
              </router-link>
            </li>
            <li>
              <a class="square" @click="logout"
                ><i class="mdi mdi-exit-to-app" style="font-size: 64px"></i
                >Sair</a
              >
            </li>
          </ul>
        </li>
      </ul>
    -->
    </div>
  </div>
</template>
<script>
import LinkAssembleias from "./LinkAssembleias.vue";
import MenuItem from "./Menu/MenuItem.vue";
import IdentificacaoCliente from "./IdentificacaoCliente.vue";

import { menu_items } from "~/store/menu";

export default {
  components: {
    LinkAssembleias,
    MenuItem,
    IdentificacaoCliente
  },
  data() {
    return {
      activeMenu: null,
    };
  },
  methods: {
    async logout() {
      try {
        await Promise.all([
          this.$store.dispatch("setCliente", {}),
          this.$store.dispatch("setRelacoes", []),
          this.$store.dispatch("setRelacaoId", 0),
          this.$store.dispatch("setCondominioId", 0),
          this.$store.dispatch("setContratoId", 0),
          this.$store.dispatch("setImovelId", 0),
          this.$store.dispatch("setRefreshToken", null),
          this.$store.dispatch("setJwt", null),
        ]);

        this.$router.replace("/login");
      } catch (error) {
        console.error(error);
      }
    },
  },
  computed: {
    menu_items() {
      return menu_items.value.filter(item => {
        return item.acl()
      })
    },
    categorias() {
      let categorias = this.menu_items.map(item => {
        return item.group
      })
      
      categorias = [...new Set(categorias)]
      return categorias.map(categoria => {
        return {
          categoria,
          items: this.menu_items.filter(item => item.group === categoria)
        }
      })

    },
    relacao() {
      return this.$store.getters.relacao;
    },
    cliente() {
      return this.$store.state.cliente;
    },
    controle_acesso() {
      return this.$store.getters.controleAcesso;
    },
    sistema() {
      if (!this.relacao) {
        return null;
      }
      return this.relacao.sistema;
    },
  },
};
</script>

<style lang="less" scoped>
.list {
  display: grid;
  grid-template-columns: 1fr;
  gap: 15px;
  list-style: none;
  padding-top: 20px;
  margin-bottom: 120px;

  .menu-item {
    margin-bottom: 10px;
    h3 {
      font-size: 24px;
      margin-bottom: 0;

      @media (max-width: 60rem) {
        font-size: 20px;
      }
    }

    .square {
      font-weight: 500;
      font-size: 16px;
      line-height: 1.1;
      color: var(--primary);
      background-color: white;
      border-radius: 15px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 135px;
      padding: 10px 10px;
      text-align: center;
      transition: background-color 0.5s, box-shadow 0.5s;
      -webkit-box-shadow: 10px 10px 5px 0px rgba(0, 0, 0, 0.75);
      -moz-box-shadow: 10px 10px 5px 0px rgba(0, 0, 0, 0.75);
      box-shadow: 1px 1px 6px 0px rgb(157 152 152 / 12%);

      i {
        font-size: 50px;
        line-height: 1;
        margin-bottom: 4px;

        &::before {
          display: block;
        }
      }

      &:hover {
        cursor: pointer;
        text-decoration: none;
        background-color: #f5f5f5;
        -webkit-box-shadow: 10px 10px 5px 0px rgba(0, 0, 0, 0.75);
        -moz-box-shadow: 10px 10px 5px 0px rgba(0, 0, 0, 0.75);
        box-shadow: 8px 7px 6px 0px rgba(157, 152, 152, 0.12);
      }
    }
    .inner-list {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 15px;
      list-style: none;

      @media (max-width: 60rem) {
        grid-template-columns: repeat(3, 1fr);
        gap: 5px;
      }

      @media(max-width: 330px) {
        grid-template-columns: repeat(2, 1fr);
      }
    }
  }

  @media (max-width: 60rem) {
    gap: 5px;

    .menu-item {
      .square {
        height: 90px;
        padding: 10px 10px;
        font-size: 12px;

        i {
          font-size: 34px !important;
        }
      }
    }
  }
}

</style>
